import React from "react";
import InputWithIcon from "../FormFields/InputWithIcon";
import { icons } from "../../assets/icons";
import CustomButton from "../CustomButton";
import { Form, Formik } from "formik";
import { profileValidation } from "../../utils/validations/profile";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext";
import ProfilePic from '../../assets/images/profile1.png'

const Profile = ({ profileData = {} }) => {
  const { apiCall } = useApi();
  const { name, email, mobile } = profileData;
  const { setUser, user } = useAuth();

  const onSubmitProfile = (values) => {
    apiCall({
      url: apiUrls.user.profile,
      dataToSend: values,
      onSuccess: (data = {}) => {
        toast.success("Profile updated successfully");
        setUser({ ...user, ...data });
      },
      method: "put",
    });
  };

  return (
    <Formik
      enableReinitialize
      validationSchema={profileValidation}
      initialValues={{ name, mobile, email }}
      onSubmit={onSubmitProfile}
    >
      {({ errors, touched, values, setFieldValue }) => {
        return (
          <Form>
            <div className="flex justify-between flex-wrap py-2">
              <div className="flex flex-col gap-y-4 py-8">
                <div className="flex pb-2">
                  <div className="font-size-small text-[var(--blackColor)] w-[13rem]">
                    Profile Photo
                  </div>
                  <div className="w-[10rem] h-[10rem] relative">
                    <img
                      // src="https://picsum.photos/200/300"
                      src={ProfilePic}
                      alt="user profile"
                      className="w-[100%] h-[100%] rounded-[0.6rem]"
                    />
                    <div className="cursor-pointer absolute bottom-0 right-0 bg-[var(--whiteColor)] pr-[0.3rem] pl-[0.6rem] py-[0.5rem] flex items-center justify-center rounded-tl-[0.8rem]">
                      <img
                        src={icons.editPhotoIcon}
                        alt="edit profile pic"
                        className="w-[2.2rem] h-[2.1rem]"
                      />
                    </div>
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="font-size-small text-[var(--blackColor)] w-[13rem]">
                    Full Name
                  </div>
                  <InputWithIcon
                    inputClassName="!mt-0"
                    containerClassName="!w-[31rem] !min-h-[4rem] !mt-0"
                    value={values?.name}
                    onChange={(e) => {
                      setFieldValue("name", e);
                    }}
                    error={touched.name && errors.name}
                  />
                </div>
                <div className="flex items-center">
                  <div className="font-size-small text-[var(--blackColor)] w-[13rem]">
                    Designation
                  </div>
                  <InputWithIcon
                    wrapperClassName="!w-[31rem] !h-[4rem]"
                    inputClassName="!mt-0"
                    value={user?.userLabel}
                    containerClassName="!min-h-[4rem] !mt-0"
                    disabled
                  />
                </div>
                <div className="flex items-center">
                  <div className="font-size-small text-[var(--blackColor)] w-[13rem]">
                    Country/Region
                  </div>
                  <InputWithIcon
                    wrapperClassName="!w-[31rem] !h-[4rem]"
                    inputClassName="!mt-0"
                    value="India/NCR"
                    containerClassName="!min-h-[4rem] !mt-0"
                    disabled
                  />
                </div>
                <div className="flex items-center">
                  <div className="font-size-small text-[var(--blackColor)] w-[13rem]">
                    Email Address
                  </div>
                  <InputWithIcon
                    wrapperClassName="!w-[31rem] !h-[4rem]"
                    inputClassName="!mt-0"
                    value={values?.email}
                    disabled
                    containerClassName="!min-h-[4rem] !mt-0"
                  />
                  <div className="flex items-center gap-x-2 ml-5 cursor-pointer">
                    <img
                      src={icons.circlePlusIcon}
                      alt="circle plus"
                      className="w-[2.4rem] h-[2.4rem]"
                    />
                    <div className="font-size-small text-[var(--textRed)] underline">
                      Add Email Address
                    </div>
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="font-size-small text-[var(--blackColor)] w-[13rem]">
                    Mobile Number
                  </div>
                  <InputWithIcon
                    value={values?.mobile}
                    containerClassName="!w-[31rem] !min-h-[4rem] !mt-0"
                    onChange={(e) => {
                      setFieldValue("mobile", e);
                    }}
                    error={touched.mobile && errors.mobile}
                  />
                  <div className="flex items-center gap-x-2 ml-5 cursor-pointer">
                    <img
                      src={icons.circlePlusIcon}
                      alt="circle plus"
                      className="w-[2.4rem] h-[2.4rem]"
                    />
                    <div className="font-size-small text-[var(--textRed)] underline">
                      Add Number
                    </div>
                  </div>
                </div>
                <CustomButton
                  title="Save Profile"
                  wrapperClassName="!px-10 !ml-[13rem] mt-10 !w-[15rem]"
                  type="submit"
                />
              </div>
              <div className="w-[30rem] bg-[var(--offWhite)] p-8 font-size-small rounded-[1rem]">
                Make sure to use accurate and up-to-date information when adding
                your email address and mobile number.
                <br />
                <br />
                If you encounter any issues during this process, contact your
                company’s IT support or relevant department for assistance.
                <br />
                <br />
                Make sure to use accurate and up-to-date information when adding
                your email address and mobile number.
                <br />
                <br />
                If you encounter any issues during this process, contact your
                company’s IT support or relevant department for assistance.
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default Profile;
